const getIsSSR = () => !(typeof window !== 'undefined' && window.document && window.document.createElement);

export default getIsSSR;
